<script lang="ts">
  let { emoji, size = 48 }: { emoji: string; size?: number } = $props();
</script>

<span class="avatar" style="--s:{size}px">{emoji}</span>

<style>
  .avatar {
    display: inline-flex; align-items: center; justify-content: center; flex: none;
    width: var(--s); height: var(--s); font-size: calc(var(--s) * 0.56); line-height: 1;
    border-radius: 50%; background: rgba(125, 249, 255, 0.1);
    box-shadow: 0 0 0 2px rgba(125, 249, 255, 0.55), 0 0 14px rgba(125, 249, 255, 0.35);
  }
</style>
